import React from 'react';

import Modal from '~components/atoms/Modal';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import CustomerManagementCreateCollateralForm from '../CustomerManagementCreateCollateralForm';
import CustomerManagementCreateCollateralSummaryModal from '../CustomerManagementCreateCollateralSummaryModal';

const CustomerManagementCreateCollateralModal = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.customer.modals.createCollateralModalIsOpen);
    const isLoading = useAppSelector(state => state.customer.loadings.createCollateral);
    const error = useAppSelector(state => state.customer.errors.createCollateral);
    const isCreateCollateralFormFilled = useAppSelector((state) => state.customer.modals.isCreateCollateralFormFilled);

    const handleModalOnClose = () => {
        dispatch(combinedActions.customerResetCreateCollateralState());
        dispatch(combinedActions.customerResetCustomerDetails());
        dispatch(combinedActions.customerClearCreateCollateralParams());
        dispatch(combinedActions.customerSetCreateCollateralModalIsOpen(false));
        dispatch(combinedActions.customerSetIsCreateCollateralFormFilled(false));
    };

    const renderContent = () => {
        if (isCreateCollateralFormFilled) {
            return <CustomerManagementCreateCollateralSummaryModal />;
        }

        return <CustomerManagementCreateCollateralForm
            submitButtonLabel='Create Collateral'
            actionButtonIsLoading={isLoading}
            error={error}
        />;
    };

    return (
        <Modal
            testId='collateral-create-customer-modal-close'
            title='Create Collateral'
            isOpen={isOpen}
            onClose={handleModalOnClose}
        >
            {renderContent()}
        </Modal>
    );
};

export default CustomerManagementCreateCollateralModal;
